(function($) {
  function productTabs() {
    $(document).on('click', '.tabs-content .technical-info a[href*="#IFRA"]', function(e) {
      e.preventDefault();
      
      $.fancybox.open({
        src  : '.tabs-content .technical-info table',
        type : 'inline',
        opts : {
          beforeShow: function( instance, current ) {
            $('.tabs-content .technical-info table').addClass('table-ifra-guidelines');
          }
        }
      });      
    });
  }
  
  function addSampleToCart() {
    $(document).on('click', '.add_sample_to_cart', function (e) {
      e.preventDefault();
      const $addToCartBtn = $(e.currentTarget);
      const variant_id = $addToCartBtn.data('variant-id');
      const data = {
        items: [
          {
            id: variant_id,
            quantity: 1
          }
        ]
      }

      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: data,
        beforeSend() {
          $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
          $addToCartBtn.find('span').removeClass('fadeInDown').addClass('animated zoomOut');
        },
        success() {
          $addToCartBtn.find('.checkmark').addClass('checkmark-active');
          $addToCartBtn.prop('disabled', true);

          window.setTimeout(() => {
            //$addToCartBtn.removeAttr('disabled').removeClass('disabled');
            $addToCartBtn.find('span').text('Free Sample Added');
            //$addToCartBtn.find('.checkmark').removeClass('checkmark-active');
            $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');
          }, 1000);

          $.ajax({
            url: '/cart.js',
            dataType: 'json',
            cache: false,
            success(cart) {
              setTimeout(function () {
                refreshCart(cart);
                if ($('body').hasClass('fancybox-active')) {
                  $.fancybox.close();
                }

                if ($('#header').is(':visible')) {
                  $('#header .cart-container').addClass('active_link');
                } else if ($('.sticky_nav--stick').length) {
                  $('.sticky_nav .cart-container').addClass('active_link');
                } else {
                  $('.top-bar .cart-container').addClass('active_link');
                }

                // block scrolling on mobile
                if (window.PXUTheme.media_queries.medium.matches) {
                  const $cartContainer = $(this).parent();
                  if ($cartContainer.hasClass('active_link')) {
                    $('body').addClass('blocked-scroll');
                  } else {
                    $('body').addClass('blocked-scroll');
                  }

                  // Scroll to the top of the page unless the header is fixed
                  const header = document.getElementById('header');
                  if (header.classList.contains('mobile_nav-fixed--false')) {
                    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
                  }
                }
              }, 500);
            },
          });
        },
        error(XMLHttpRequest) {
          let response = eval(`(${XMLHttpRequest.responseText})`);
          response = response.description;
          $('.warning').remove();

          const warning = `<p class="warning animated bounceIn">${response.replace('All 1 ', 'All ')}</p>`;
          $addToCartForm.after(warning);
          $addToCartBtn.removeAttr('disabled').removeClass('disabled');
          $addToCartBtn.find('span').text(window.PXUTheme.translation.add_to_cart).removeClass('zoomOut').addClass('zoomIn');
        },
      });

      return false;
    });    
  }
  
  function responsiveTable() {
      if ($('div.rte > table').length > 0) {
          $('div.rte > table').each(function() {
              if ($(this).find('tr:first-child td').length > 2) {
                  $(this).wrap('<div class="table-responsive"></div>');
              }
          })
      }      
  }
  
  $(document).ready(function() {
    productTabs();
    addSampleToCart();
    responsiveTable();
  });
})(jQuery);